import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { hasAdminPermissions } from 'app/helpers/browse/admin';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import AdminBrowseHomeEditPage from './AdminBrowseHomeEditPage';

const AdminBrowseHomeEditPageContainer = ({ browseHomePageId }) => {
  const currentUser = useSelector(selectCurrentUser);

  const [state, setState] = useState({
    browseHomePageIndex: {},
    isLoading: true,
    isSaved: false
  });

  useEffect(() => {
    const browseHomePageIndex = JSON.parse(localStorage.getItem('browseHomePageIndex')) || {};

    setState(prevState => {
      return {
        ...prevState,
        browseHomePageIndex,
        isLoading: false
      };
    });
  }, [setState]);

  useEffect(() => {
    setTimeout(() => {
      setState(prevState => {
        return {
          ...prevState,
          isSaved: false
        };
      });
    }, 5 * 1000);
  }, [setState, state.isSaved]);

  const canViewPage = hasAdminPermissions(currentUser);
  if (!canViewPage) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.FORBIDDEN} />;
  }

  const saveBrowseHomePage = browseHomePage => {
    const { browseHomePageIndex } = state;

    browseHomePageIndex[browseHomePage.browseHomePageId] = browseHomePage;

    window.localStorage.setItem('browseHomePageIndex', JSON.stringify(browseHomePageIndex));
    setState(prevState => {
      return {
        ...prevState,
        isLoading: false,
        isSaved: true,
        browseHomePageIndex
      };
    });
  };

  const { browseHomePageIndex, isLoading, isSaved } = state;
  if (isLoading) {
    return <p>Loading...</p>;
  }

  const browseHomePage = browseHomePageIndex[browseHomePageId] || { browseHomePageId };
  return (
    <AdminBrowseHomeEditPage browseHomePage={browseHomePage} hasSuccessNotice={isSaved} onSave={saveBrowseHomePage} />
  );
};

AdminBrowseHomeEditPageContainer.propTypes = {
  browseHomePageId: PropTypes.string
};

export default AdminBrowseHomeEditPageContainer;
